import { AsyncResult, ApiAction, Action } from '../../../index';

// Types
import { DataUploadPortalConfig } from '@/types/data-upload-config';
import { DataUploadConfigState } from '../../types/data-upload-config';

// Utils
import { correlateApi } from '@/utils/api';
import api from '../../../redux-api';

const GET_FILE_UPLOAD_URL: ApiAction = {
  type: 'connect/auth/file-upload',
  endpoint: 'uploads/file-upload-url',
};

const GET_DATA_UPLOAD_PORTAL_CONFIGS: ApiAction = {
  type: 'connect/enteprise/dataUploadPortal/',
  endpoint: 'enterprises/:id/data-upload-portal',
};

const ADD_DATA_UPLOAD_FILE: ApiAction = {
  type: 'connect/enteprise/dataUploadFile/',
  endpoint: 'enterprises/:id/data-upload-file',
};

const TRIGGER_DATA_UPLOAD_ACTION: ApiAction = {
  type: 'connect/enteprise/dataUpload/',
  endpoint: 'enterprises/:id/data-upload',
};

export const getFileUploadUrl =
  (file: File): AsyncResult<string> =>
  (dispatch, getState) => {
    const query = { fileType: file.type, fileName: file.name };
    return api
      .get(GET_FILE_UPLOAD_URL, query)
      .then((res: { url: string; signedRequest: string }) =>
        correlateApi.put(res.signedRequest, file, { withCredentials: false, headers: { 'Content-Type': file.type } }).then(() => res.url),
      );
  };

export const getDataUploadPortalConfigs = (): AsyncResult<Array<DataUploadPortalConfig>> => (dispatch, getState) => {
  const state = getState();
  const {
    enterprise: { details },
  } = state;
  if (!details) {
    return Promise.reject();
  }
  return api.get(GET_DATA_UPLOAD_PORTAL_CONFIGS, { id: details._id }).then((res: { data: any }) => res.data);
};

export const addDataUploadFile =
  (url: string, configKey: string, assetKey: string): AsyncResult<void> =>
  (dispatch, getState) => {
    const state = getState();
    const {
      enterprise: { details },
    } = state;
    if (!details) {
      return Promise.reject();
    }
    return api.post(ADD_DATA_UPLOAD_FILE, { id: details._id }, { url, configKey, assetKey });
  };

export const triggerDataUploadAction =
  (configKey: string, actionKey: string): AsyncResult<void> =>
  (dispatch, getState) => {
    const state = getState();
    const {
      enterprise: { details },
    } = state;

    if (!details) {
      return Promise.reject();
    }
    return api.post(TRIGGER_DATA_UPLOAD_ACTION, { id: details._id }, { configKey, actionKey });
  };

const INITIAL_STATE = {
  configs: [],
};

export default function reducer(state: DataUploadConfigState = INITIAL_STATE, action: Action): any {
  switch (action.type) {
    case `${GET_DATA_UPLOAD_PORTAL_CONFIGS.type}_SUCCESS`: {
      return {
        ...state,
        configs: action.data.data,
      };
    }
    default:
      return state;
  }
}
